import {
  Box,
  Grid,
  Stack,
  useTheme,
  Container,
  CircularProgress,
} from "@mui/material";
import React from "react";
import { useRouter } from "next/router";

import { AppHeader } from "@/shared/modules/AppHeader/AppHeader";
import { HowItWorks } from "@/shared/modules/HowItWorks/HowItWorks";
import { FaqSection } from "@/shared/modules/FaqSection/FaqSection";
import { PurchaseSeats } from "@/shared/modules/PurchaseSeats/PurchaseSeats";
import { BottomBar } from "@/shared/modules/PurchaseSeats/BottomBar/BottomBar";

import { routes } from "@/global/routes";
import { useAppStore } from "@/global/store";
import { selectUser } from "@/global/store/data/user";
import { useGlobalApis } from "@/global/hooks/useGlobalApis";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { withTeamConfig } from "@/global/context/AppProviderRoot";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { authUIDs, purchaseSeatsTabUIDs } from "@/global/config/constants";
import { PurchaseCredit } from "@/shared/modules/PurchaseCredit/PurchaseCredit";
import { PurchaseGiftCard } from "@/shared/modules/PurchaseGiftCard/PurchaseGiftCard";

export default withTeamConfig(function SelectGamesPage(props: any) {
  const router = useRouter();
  const theme = useTheme();
  const { sm: smDown } = useCssMediaQuery("down");
  const { availableCreditEnabled, giftCardConfigs, faqs } = useTeamConfig();
  const user = useAppStore(selectUser);
  const { purchaseCreditConfigs, teamSchema, authConfigs } = useTeamConfig();
  const { isLandingPurchaseCreditEnabled } = purchaseCreditConfigs;
  const { handleGetCreditReport } = useGlobalApis();
  const purchaseSeatTab = router.query.purchaseSeatTab as string;

  React.useEffect(() => {
    if (availableCreditEnabled && user) handleGetCreditReport();
  }, [user]);

  React.useEffect(() => {
    if (authConfigs?.isLoginRequired && !user) {
      router.push({
        pathname: routes.auth,
        query: { teamSchema, authType: authUIDs.login },
      });
      return;
    }
  }, [user]);

  if (!user && authConfigs?.isLoginRequired) {
    return (
      <Box height={"100vh"}>
        <Stack
          width={"100%"}
          height="100vh"
          alignItems={"center"}
          justifyContent={"center"}
        >
          <CircularProgress size={"64px"} color="primary" />
        </Stack>
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ marginBottom: "120px" }}>
        <AppHeader />

        <Box sx={{ overflowX: "hidden" }}>
          <PurchaseSeats />
        </Box>

        {giftCardConfigs.isLandingPageGiftCardEnabled ? (
          <Box mt={2} mb={4}>
            <Container
              maxWidth={"xl"}
              sx={{ paddingX: smDown ? 0 : "inherit" }}
            >
              <PurchaseGiftCard
                isEmbeddedCheckout={false}
                authRedirectPath={routes.landing}
              />
            </Container>
          </Box>
        ) : null}

        {isLandingPurchaseCreditEnabled ? (
          <Box pb={4}>
            <Container
              maxWidth="xl"
              sx={{
                padding: smDown ? "0px" : "inherit",
              }}
            >
              <Box>
                <Grid container spacing={12}>
                  <Grid item xs={12}>
                    <PurchaseCredit
                      authRedirectPath={routes.purchaseSeats}
                      skipRegister={true}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        ) : null}

        <Box bgcolor={theme.palette.background.paper} py={12}>
          <Container maxWidth="xl">
            <Box>
              <Grid container spacing={12}>
                <Grid item xs={12} lg={faqs.length === 0 ? 12 : 6}>
                  <HowItWorks />
                </Grid>
                <Grid item xs={12} lg={6}>
                  <FaqSection />
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Box>
      </Box>
      {purchaseSeatTab !== purchaseSeatsTabUIDs.packages && <BottomBar />}
    </>
  );
});
